/**
 * Is a URL the app was opened with one of our own web pages?
 *
 * The app opens on two kinds of link: an https app link (a quote, a job, a
 * push tap), which is a page to navigate to, and a custom-scheme link that
 * belongs to a native SDK — `mucka://…?metaWearablesAction=…`, the Meta AI app
 * handing back to the glasses plugin. Navigating to the second reloads the
 * WebView in the middle of the hand-off it exists to finish.
 */
export function isWebLink(url: URL): boolean {
  return url.protocol === 'https:' || url.protocol === 'http:';
}
